/** Household sizes a weeknight dinner gets made in.
 *
 * A fixed ladder rather than multiples of the plan, because the question is
 * how many people are eating, and that answer does not scale with what the
 * week happened to suggest.
 *
 * Shared by the two controls that ask it -- what a dinner is planned for, and
 * what it turned out to be cooked for -- so the two cannot start offering
 * different numbers for the same question.
 */
export const SERVING_LADDER = [1, 2, 4, 6, 8];

export function servingsWord(count: number) {
  return `${count} serving${count === 1 ? '' : 's'}`;
}

/** The ladder, with `current` folded in if it is not already on it.
 *
 * A dinner can hold any number the API accepts, and a menu that silently
 * omitted the size a dinner actually is would give no way back to it.
 */
export function ladderWith(current: number): number[] {
  return SERVING_LADDER.includes(current)
    ? SERVING_LADDER
    : [...SERVING_LADDER, current].sort((a, b) => a - b);
}
